import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

const baseCommentSchema = baseSchema.extend({
  createdAt: z.string(),
  lastEditedAt: z.string().nullish(),
  authorId: z.string(),
  value: z.string().nullable(),
  reactions: z.record(z.string(), z.string().array()),
  replyId: z.string().nullable(),
  streamURL: z.string().nullish(),
  metadata: z.record(z.string(), z.string()).nullish(),
})

export const rootCommentSchema = baseCommentSchema.extend({
  type: z.literal('root'),
  status: z.enum(['open', 'resolved']),
  branchId: z.string(),
  blockId: z.string().nullish(),
  siteId: z.string().nullish(),
  blockParentId: z.string().nullish(),
  agentId: z.string().nullish(),
  ref: z.enum(['diff', 'block', 'rich-text', 'site', 'agent']).nullish(),
  resolvedBy: z.string().nullish(),
  label: z.string().nullish(),
  aiStatus: z.enum(['pending', 'processing', 'completed', 'failed']).nullish(),
})

export const commentSchema = baseCommentSchema.and(
  z.discriminatedUnion('type', [
    rootCommentSchema,
    z.object({
      type: z.literal('reply'),
      parentId: z.string(),
      rootId: z.string().optional(),
    }),
  ])
)

export type Comment = z.infer<typeof commentSchema>
export type RootComment = Comment & { type: 'root' }
export type ReplyComment = Comment & { type: 'reply' }
export type CommentUpdate = Update<Comment>

export const commentBaseOps = generate('comment', commentSchema.parse)

// Helper functions
export const isRootComment = (comment: Comment): comment is RootComment =>
  comment.type === 'root'

export const isReplyComment = (comment: Comment): comment is ReplyComment =>
  comment.type === 'reply'
